<div class="header-dependente">
  <div class="form-card">
    <div class="painel-perfil">
      <div class="profile-avatar">
          <!-- <input id="custom-input" type="file" (change)="fileChangeListener($event)"> -->
          <img-cropper #cropper [image]="data" [settings]="cropperSettings" style="display: none;"></img-cropper>
          <img [src]="data.image" [width]="cropperSettings.croppedWidth" [height]="cropperSettings.croppedHeight">
      </div>
      <!-- <p class="header-dependente msg-avatar">Clique na imagem e selecione a foto.</p> -->
    </div>

    <form class="form">
      <app-input [inputModel]="user.nameInputModel" (isInputValid)="setFormStatus($event, 'name')" [(value)]="user.nome"></app-input>
      <app-input [inputModel]="user.documentInputModel" *ngIf="!tempCpf" (isInputValid)="setFormStatus($event, 'cpf')" [(value)]="user.cpf"></app-input>
      <app-input [inputModel]="user.documentInputModel" *ngIf="tempCpf" [(value)]="user.cpf"></app-input>
      <app-input [inputModel]="user.emailInputModel" (isInputValid)="setFormStatus($event, 'email')" [(value)]="user.email"></app-input>

      <app-input [inputModel]="user.endereco.CEPInputModel" [(value)]="user.endereco.CEP" (focusout)="buscaCep()"></app-input>
      <app-input [inputModel]="user.endereco.logradouroInputModel" [(value)]="user.endereco.logradouro"></app-input>
      <app-input [inputModel]="user.endereco.numeroInputModel" [(value)]="user.endereco.numero"></app-input>
      <app-input [inputModel]="user.endereco.complementoInputModel" [(value)]="user.endereco.complemento"></app-input>
      <app-input [inputModel]="user.endereco.bairroInputModel" [(value)]="user.endereco.bairro"></app-input>
      <app-input [inputModel]="user.endereco.cidadeNomeInputModel" [(value)]="user.endereco.cidadeNome"></app-input>
      <app-input [inputModel]="user.endereco.estadoUFInputModel" [(value)]="user.endereco.estadoUF"></app-input>

      <app-input [inputModel]="user.dddInputModel" [(value)]="user.ddd"></app-input>
      <app-input [inputModel]="user.phoneInputModel" [(value)]="user.telefone"></app-input>
    </form>
    <button (click)="changePassword()" mat-raised-button class="trocar-senha outlined">
      Trocar senha
    </button>
    <button (click)="update()" mat-raised-button class="trocar-senha">
        Atualizar
    </button>
    <p (click)="deleteAccount()" class="delete-account">Excluir minha conta</p>
    </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/account/account.component.html